export { DocPeekPreview } from './doc-peek-view';
